import type {
  DataSourceMapping,
  EntityDataSourceType,
} from '@web-config-app/core';
import type { GDSSelectProps } from '@leagueplatform/genesis-core';
import {
  isMergedDataSourceValue,
  getMergedDataSourceValue,
} from './get-merged-data-source-value';
import type { DataSourceValue } from '../../types/data-source';
import { getMappedDataSourceEnumOptions } from './get-mapped-data-source-enum-options';
import { getMappedDataSourceNestedEnumOptions } from './get-mapped-data-source-grouped-enum-options';

const mappings: Record<
  EntityDataSourceType,
  (
    data: DataSourceValue,
    mapping: DataSourceMapping | undefined,
  ) => { enumOptions: GDSSelectProps['options'] } | undefined
> = {
  enumOptions: getMappedDataSourceEnumOptions,
  groupedEnumOptions: getMappedDataSourceNestedEnumOptions,
};

export interface GetMappedDataSourceProps {
  dataSourceValue: DataSourceValue;
  type: EntityDataSourceType | undefined;
  mapping: DataSourceMapping;
}

export function getMappedDataSource({
  dataSourceValue,
  type,
  mapping,
}: GetMappedDataSourceProps) {
  const mapper = type && mappings[type];

  if (!mapper && !!type) {
    /**
     * Throwing a warning here because the annotation specified a type but it doesn't match any known
     * mapping function so it was probably a typo.
     */
    // eslint-disable-next-line no-console
    console.error(
      `Could not find a data source mapper corresponding to '${type}'`,
    );
  }

  const data = isMergedDataSourceValue(dataSourceValue)
    ? getMergedDataSourceValue(dataSourceValue)
    : dataSourceValue;

  return mapper ? mapper(data, mapping) : undefined;
}
